import { animated } from "@react-spring/web";
import classNames from "classnames";
import { Chip, FloatingIconButton } from "@livingmap/core-ui-v2";

import styles from "./SearchTags.module.scss";
import { useSlider, SliderOptions } from "../../hooks/useSlider";

export enum CategoryType {
  NORMAL = "normal",
  BESPOKE = "bespoke",
}

export type Category = {
  id: number;
  name: string;
  type: CategoryType;
};

interface Props extends SliderOptions {
  dataQA: string;
  data: Category[];
  className?: string;
  onClick: (selection: Category) => void;
  active?: Category | null;
  mobile?: boolean;
}

const SearchTags: React.FC<Props> = ({
  dataQA,
  data,
  enableArrows,
  initialOffset,
  itemGap,
  className,
  onClick,
  active = null,
  mobile,
}) => {
  const {
    sliderContainerRef,
    firstItemIsVisible,
    lastItemIsVisible,
    scrollPrev,
    scrollNext,
    animationStyles,
    dragAttributes,
  } = useSlider({ enableArrows, initialOffset, itemGap });

  const handleOnClick = (selection: Category) => {
    onClick(selection);
  };
  return (
    <div data-qa={dataQA} className={classNames(styles.container, className)}>
      {enableArrows && !firstItemIsVisible && (
        <FloatingIconButton
          dataQA="arrow-left"
          icon="ChevronLeftIcon"
          className={styles.arrowLeft}
          size="small"
          rounded
          onClick={scrollPrev}
        />
      )}
      {enableArrows && !lastItemIsVisible && (
        <FloatingIconButton
          dataQA="arrow-right"
          icon="ChevronRightIcon"
          className={styles.arrowRight}
          size="small"
          rounded
          onClick={scrollNext}
        />
      )}
      <div className={styles.sliderContainer}>
        <div style={{ position: "relative" }}>
          <animated.div
            ref={sliderContainerRef}
            style={{ ...animationStyles, touchAction: "none" }}
            className={styles.slider}
            {...dragAttributes()}
          >
            {data.map((item) => (
              <div
                key={`${item.id}_${item.type}`}
                className={styles.tagWrapper}
              >
                <Chip
                  dataQA="search-tag"
                  onClick={() => handleOnClick(item)}
                  noShadow={true}
                  className={classNames(styles.tag, {
                    [styles.mobile]: mobile,
                    [styles.active]:
                      active &&
                      item.id === active.id &&
                      item.type === active.type,
                  })}
                  active={
                    active
                      ? item.id === active.id && item.type === active.type
                      : false
                  }
                  rounded
                >
                  {item.name}
                </Chip>
              </div>
            ))}
          </animated.div>
        </div>
      </div>
    </div>
  );
};

export default SearchTags;
